import {
  Card,
  DataDisplay,
  formatBoolean,
  formatSchoolYear,
  Grid,
  GridBreak,
  pn,
  Stack,
  useElementBreakpoints,
} from "@compass/core";
import { Select } from "components";
import { LkStudentDisplayFieldId, StudentAprUb as StudentAprUbModel, StudentAprUbResource } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentAprUb = (props: { initialLoad: boolean; studentId: number }) => {
  const { breakpointsRef, smallFieldBreakpoints, mediumFieldBreakpoints, largeFieldBreakpoints, fullFieldBreakpoints } =
    useElementBreakpoints();

  // const navigate = useNavigate();
  // const { matchTemplatePath } = useRouter();
  const [apr, setApr] = useState<StudentAprUbModel>({} as StudentAprUbModel);
  const [resource, setResource] = useState<StudentAprUbResource>({} as StudentAprUbResource);
  const [selectedSchoolyear, setSelectedSchoolyear] = useState<number>();
  const [schoolYears, setSchoolYears] = useState<number[]>([]);

  useEffect(() => {
    if (props.initialLoad) {
      ApiService.students.getAprUb(props.studentId).then((response) => {
        setApr(response);

        if (response.enrollments && response.enrollments?.length > 0) {
          const schoolYears = response.enrollments.map((x) => x.schoolYear!);
          setSchoolYears(schoolYears);
          setSelectedSchoolyear(schoolYears[0]);
        }
      });

      ApiService.students.getAprUbResource().then((response) => {
        setResource(response);
      });
    }
  }, [props.initialLoad]);

  const properties = resource.properties || [];

  const studentDisplayFields = resource.studentDisplayFields ?? [];
  const atRiskStdTestDisplayField = studentDisplayFields.find(
    (field) => field.id === LkStudentDisplayFieldId.AtRiskStdTest
  );
  const atRiskAlgebraDisplayField = studentDisplayFields.find(
    (field) => field.id === LkStudentDisplayFieldId.AtRiskAlgebra
  );
  const atRiskLowGpaDisplayField = studentDisplayFields.find(
    (field) => field.id === LkStudentDisplayFieldId.AtRiskLowGpa
  );
  const otherNeedDisplayField = studentDisplayFields.find((field) => field.id === LkStudentDisplayFieldId.OtherNeed);
  const disconnectedDisplayField = studentDisplayFields.find(
    (field) => field.id === LkStudentDisplayFieldId.Disconnected
  );

  // const properties = resource.properties || [];

  const eligibilityField = () => {
    const propertyName = pn<StudentAprUbModel>("eligibility");
    const property = properties.find((x) => x.propertyName === propertyName);

    return <DataDisplay label={property?.displayName}>{apr.eligibility}</DataDisplay>;
  };

  const atRiskStdTestField = () => {
    return <DataDisplay label={atRiskStdTestDisplayField?.displayName}>{apr.atRiskStdTest}</DataDisplay>;
  };

  const atRiskAlgebraField = () => {
    return <DataDisplay label={atRiskAlgebraDisplayField?.displayName}>{apr.atRiskAlgebra}</DataDisplay>;
  };

  const atRiskLowGpaField = () => {
    return <DataDisplay label={atRiskLowGpaDisplayField?.displayName}>{apr.atRiskLowGpa}</DataDisplay>;
  };

  const otherNeedField = () => {
    return <DataDisplay label={otherNeedDisplayField?.displayName}>{apr.otherNeed}</DataDisplay>;
  };

  const disconnectedField = () => {
    return <DataDisplay label={disconnectedDisplayField?.displayName}>{formatBoolean(apr.disconnected)}</DataDisplay>;
  };

  const schoolYearSelect = () => {
    return (
      <Select
        label="School Year"
        value={selectedSchoolyear}
        options={schoolYears}
        onChange={(e, value) => setSelectedSchoolyear(value)}
        getOptionLabel={(year: number) => formatSchoolYear(year)!}
        renderOption={(props, year) => <li {...props}>{formatSchoolYear(year)}</li>}
      />
    );
  };

  const enrollmentParticipantStatus = () => {
    const enrollment = apr.enrollments?.find((x) => x.schoolYear === selectedSchoolyear);
    return <DataDisplay label="Participant Status">{enrollment?.participantStatus}</DataDisplay>;
  };

  return (
    <Card>
      <Stack ref={breakpointsRef} spacing="md" height="100%" overflow="auto">
        <Grid container spacing="sm">
          <Grid item xs={mediumFieldBreakpoints}>
            {eligibilityField()}
          </Grid>

          {atRiskStdTestDisplayField && (
            <Grid item xs={fullFieldBreakpoints}>
              {atRiskStdTestField()}
            </Grid>
          )}

          {atRiskLowGpaDisplayField && (
            <Grid item xs={smallFieldBreakpoints}>
              {atRiskLowGpaField()}
            </Grid>
          )}

          {atRiskAlgebraDisplayField && (
            <Grid item xs={smallFieldBreakpoints}>
              {atRiskAlgebraField()}
            </Grid>
          )}

          {disconnectedDisplayField && (
            <Grid item xs={smallFieldBreakpoints}>
              {disconnectedField()}
            </Grid>
          )}

          {otherNeedDisplayField && (
            <Grid item xs={smallFieldBreakpoints}>
              {otherNeedField()}
            </Grid>
          )}

          <GridBreak />

          <Grid item xs={smallFieldBreakpoints}>
            {schoolYearSelect()}
          </Grid>

          <Grid item xs={smallFieldBreakpoints}>
            {enrollmentParticipantStatus()}
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
